export const reactionKeys = {
    SHOW_REACTION: 'SHOW_REACTION',
    SHOW_GIPHY: 'SHOW_GIPHY',
    TRIGGER_GIPHY_MODAL: 'TRIGGER_GIPHY_MODAL',
}
